import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuokkaDone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 201,
	height: 240,
	viewBox: "0 0 201 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M97.8108 156.626C97.8108 156.626 56.9014 156.936 52.9405 197.403C48.9796 237.87 -11.0417 236.431 2.66307 191.661C2.66307 191.661 6.15785 223.304 28.0246 214.811C49.8914 206.318 31.7259 169.801 61.5708 149.052C91.4156 128.302 97.8108 156.626 97.8108 156.626Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.786 196.831C112.786 196.831 113.477 196.316 115.713 197.74C117.949 199.164 114.181 199.812 114.181 199.812L112.786 196.831Z",
			fill: "#0E1680"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.688 149.708C140.688 149.708 142.534 156.571 139.944 166.427C137.354 176.282 121.731 202.835 121.731 202.835C121.731 202.835 141.296 210.157 141.285 216.302L139.713 216.586C139.713 216.586 142.282 218.448 141.992 220.734C141.992 220.734 134.421 219.148 131.567 216.571L131.279 217.999C129.262 216.546 127.165 215.206 124.998 213.987C122.286 212.553 110.144 209.531 110.006 206.53C109.868 203.528 111.156 202.816 113.451 197.676C115.747 192.535 114.054 180.386 114.054 180.386L140.688 149.708Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.881 212.331C121.072 209.462 112.395 206.704 108.462 205.532C108.41 203.302 109.813 200.494 112.789 196.836C112.897 197.081 116.135 204.412 123.912 200.011L123.115 202.593C123.115 202.593 135.847 206.272 140.964 212.053C141.612 212.775 142.188 213.56 142.683 214.395C141.305 213.894 138.627 213.563 134.81 215.922C134.162 216.317 133.538 216.749 132.94 217.215C130.678 215.46 128.321 213.829 125.881 212.331Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.682 214.397C145.213 218.68 143.944 222.373 139.065 222.169C137.724 221.029 135.475 219.153 132.939 217.217C133.537 216.75 134.162 216.319 134.809 215.924C138.626 213.564 141.305 213.895 142.682 214.397Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.829 219.406C131.404 218.562 132.118 217.821 132.941 217.216C135.476 219.151 137.726 221.028 139.066 222.168C138.332 222.136 137.602 222.036 136.886 221.869C134.745 221.389 132.698 220.557 130.829 219.406Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.463 205.531C112.396 206.703 121.072 209.461 125.882 212.33C128.322 213.829 130.679 215.46 132.941 217.217C132.118 217.823 131.403 218.563 130.828 219.408C127.16 217.216 124.137 214.337 117.463 212.439C111.654 210.782 108.534 208.763 108.463 205.531Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.093 202.895C124.093 202.895 124.828 202.656 125.011 203.193L124.794 206.035C124.794 206.035 124.143 206.331 123.861 205.906L124.093 202.895Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.662 203.967L125.958 203.52C125.958 203.52 126.524 203.394 126.735 203.805L122.846 204.505C122.753 204.455 122.681 204.372 122.647 204.272C122.613 204.172 122.618 204.063 122.662 203.967Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.134 203.998C127.134 203.998 127.876 203.779 128.044 204.321L127.748 207.156C127.748 207.156 127.089 207.434 126.819 207.002L127.134 203.998Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.675 205.029L128.982 204.674C128.982 204.674 129.551 204.563 129.751 204.979L125.843 205.571C125.751 205.519 125.683 205.434 125.651 205.333C125.62 205.233 125.629 205.124 125.675 205.029Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.322 205.248C130.322 205.248 131.077 205.081 131.207 205.634L130.716 208.442C130.716 208.442 130.039 208.673 129.8 208.223L130.322 205.248Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.795 206.178L132.119 206.052C132.119 206.052 132.697 205.981 132.865 206.41L128.924 206.731C128.836 206.672 128.774 206.582 128.75 206.48C128.726 206.377 128.742 206.269 128.795 206.178Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.423 206.702C133.423 206.702 134.188 206.586 134.28 207.147L133.602 209.915C133.602 209.915 132.912 210.101 132.703 209.636L133.423 206.702Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.837 207.526L135.161 207.623C135.161 207.623 135.739 207.591 135.881 208.03L131.929 208.087C131.846 208.023 131.789 207.929 131.772 207.825C131.755 207.721 131.778 207.614 131.837 207.526Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.731 202.833L123.113 202.589L126 196.545C126 196.545 122.975 195.026 121.053 197.999L121.731 202.833Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.74 202.542C120.508 202.626 120.269 202.686 120.025 202.722",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.406 202.723C117.838 202.633 117.288 202.452 116.777 202.187C115.621 201.54 114.556 200.742 113.61 199.814",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10,
			strokeDasharray: "0.32 0.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.028 199.246C112.708 198.922 112.521 198.712 112.521 198.712C112.521 198.712 112.381 198.961 112.165 199.357",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.418 200.772C111.058 201.477 110.678 202.26 110.393 202.943",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10,
			strokeDasharray: "0.32 0.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.107 203.689C110.022 203.921 109.964 204.161 109.934 204.405C109.934 204.405 110.19 204.438 110.661 204.525",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.046 204.812C115.621 205.662 119.084 206.93 122.363 208.589C125.635 210.196 128.743 212.117 131.643 214.326",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10,
			strokeDasharray: "0.32 0.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.196 214.769C132.57 215.075 132.757 215.247 132.757 215.247C132.757 215.247 132.967 215.069 133.347 214.805",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.418 214.129C135.694 213.373 137.107 212.878 138.575 212.671",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10,
			strokeDasharray: "0.32 0.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M139.209 212.622C139.454 212.613 139.7 212.617 139.945 212.633",
			stroke: "#0E1680",
			strokeWidth: .0790284,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.0131 149.44C63.0131 149.44 58.3007 156.55 59.0617 161.821C59.5263 160.694 60.2834 159.711 61.2547 158.975C61.2547 158.975 59.2724 164.395 60.5452 167.74C60.5452 167.74 60.6151 163.35 63.2212 161.998C65.8273 160.647 63.0131 149.44 63.0131 149.44Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.0958 56.5945C38.9423 52.5001 41.7092 50.0312 37.9821 45.5059C35.2604 42.1992 29.4013 44.5909 26.2144 46.2652C26.2133 46.2684 26.2111 46.271 26.2081 46.2726C26.0218 46.5718 25.8515 46.8807 25.6978 47.198C20.8162 57.3034 45.8419 69.0216 45.8419 69.0216L47.0958 56.5945Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.9815 45.5044C41.7086 50.0318 38.9417 52.5007 47.0953 56.593H47.0995L48.695 40.7852C48.695 40.7852 31.734 37.3272 26.2139 46.2632C29.4007 44.5894 35.2588 42.1978 37.9815 45.5044Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.6916 40.7833C48.6916 40.7833 46.27 37.5639 43.5503 36.8281C43.9071 37.3887 44.1898 37.9932 44.3912 38.6265C44.3912 38.6265 41.3999 36.9211 39.3818 37.6842C39.3818 37.6842 42.0925 38.7878 42.7852 40.6582C43.4778 42.5285 48.6916 40.7833 48.6916 40.7833Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.536 16.363C75.4434 13.7217 81.6199 40.656 81.6199 40.656L69.2085 39.2655H69.2048C66.9282 30.4308 63.9316 32.6149 60.2881 28.0134C57.63 24.6558 61.2152 19.4252 63.5243 16.6693C63.8557 16.5488 64.1934 16.4465 64.536 16.363Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.5233 16.667C61.2141 19.4229 57.629 24.6551 60.2871 28.0111C63.9306 32.6126 66.9272 30.4285 69.2038 39.2632L53.4189 37.4916C53.4189 37.4916 53.6171 20.1723 63.5233 16.667Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.4159 37.4912C53.4159 37.4912 50.7794 34.4431 50.6338 31.6315C51.1065 32.0987 51.6377 32.5029 52.2141 32.834C52.2141 32.834 51.1782 29.5505 52.3491 27.7363C52.3491 27.7363 52.8584 30.6189 54.539 31.6899C56.2196 32.7609 53.4159 37.4912 53.4159 37.4912Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.281 33.6915C122.281 33.6915 134.236 32.5354 145.463 44.7171C145.463 44.7171 136.926 47.545 130.393 44.2641C123.86 40.9833 122.281 33.6915 122.281 33.6915Z",
			fill: "#0E1680"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.275 27.502L126.171 38.093C126.171 38.093 126.49 42.9278 136.169 43.6373L142.043 34.7106L130.275 27.502Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.964 35.1588C136.776 36.7265 131.267 32.3735 130.377 30.182C129.487 27.9906 122.018 28.4667 121.944 24.6062C121.87 20.7456 128.444 22.5177 128.444 22.5177C128.444 22.5177 119.703 14.8271 121.414 10.9103C123.126 6.99358 129.443 12.8779 129.443 12.8779C129.443 12.8779 124.467 3.61969 129.631 0.462839C134.794 -2.69401 135.575 11.3318 135.575 11.3318C135.575 11.3318 137.099 -0.0148578 141.637 1.48342C146.176 2.9817 141.585 15.1015 141.585 15.1015C141.585 15.1015 150.63 9.50405 152.198 13.2689C153.766 17.0338 143.886 22.2229 143.886 22.2229C143.886 22.2229 149.696 31.889 140.964 35.1588Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.282 33.6904C122.282 33.6904 131.835 44.674 145.461 44.7197L138.141 54.7573C128.323 52.9521 121.78 43.5462 119.176 39.0734L122.282 33.6904Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.523 65.2014C122.433 62.3052 116.43 54.1915 113.351 49.157L119.175 39.0742C121.779 43.547 128.322 52.9529 138.14 54.7581L130.523 65.2014Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.349 49.1582C116.429 54.1928 122.432 62.3064 130.522 65.2026V65.2052L122.339 76.4211C117.452 72.7355 111.026 66.4949 108.365 57.7879C108.365 57.7879 108.361 57.7879 108.365 57.7853L113.349 49.1582Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.306 81.5023C106.327 76.3411 103.881 70.3538 102.819 67.3898L108.367 57.791C111.028 66.498 117.455 72.7386 122.341 76.4242L115.036 86.4423C113.272 84.9855 111.685 83.3276 110.306 81.5023Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.7083 84.0131C83.6524 75.0319 92.9585 70.5764 101.34 69.9531L102.82 67.3896C103.882 70.3536 106.327 76.341 110.306 81.5022C92.3999 102.572 69.8625 106.154 69.8625 106.154L69.1746 106.542C67.9238 101.477 66.5186 95.7078 66.5186 95.7078C66.5314 93.287 67.2087 90.9163 68.4765 88.8541C69.7443 86.7919 71.5541 85.1173 73.7083 84.0131Z",
			fill: "#3E2DE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.664 94.7818C106.982 112.428 83.153 117.323 74.445 118.569C73.4736 116.978 72.3544 115.482 71.1021 114.102C71.0385 114.03 70.153 110.5 69.1729 106.538L69.8608 106.151C69.8608 106.151 92.3981 102.569 110.305 81.499C111.683 83.3242 113.271 84.9822 115.034 86.439C117.916 88.9925 120.831 91.7505 123.664 94.7818Z",
			fill: "#D8BFAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.894 104.899C120.976 113.727 98.2234 129.187 76.5552 125.468C76.5994 123.407 75.9913 121.148 74.4463 118.57C83.1543 117.324 106.983 112.429 123.665 94.7832C126.646 97.9546 129.395 101.335 131.894 104.899Z",
			fill: "#3E2DE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.562 123.547C112.04 143.786 82.0567 134.965 74.1816 132.074C75.5648 130.015 76.5066 127.876 76.5549 125.469C98.2246 129.188 120.977 113.727 131.893 104.899C135.925 110.661 139.177 116.931 141.562 123.547Z",
			fill: "#D8BFAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.1804 132.074C82.0555 134.964 112.039 143.787 141.561 123.547V123.55L141.794 124.205C143.614 129.21 144.803 134.424 145.331 139.724C138.289 144.196 97.3127 168.028 71.835 135.125C72.672 134.152 73.455 133.133 74.1804 132.074Z",
			fill: "#3E2DE2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.7189 172.432C54.8732 151.565 65.0459 143.197 71.8383 135.125C97.316 168.028 138.29 144.196 145.335 139.723C149.539 187.061 80.9311 188.188 69.7189 172.432Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.1592 207.821C74.1592 207.821 78.7902 202.841 87.3316 206.087C86.946 207.195 86.3013 208.195 85.4512 209.003C84.601 209.811 83.57 210.404 82.4442 210.733C78.4691 212.006 74.1592 207.821 74.1592 207.821Z",
			fill: "#0E1680"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.8915 171.902C91.8915 171.902 96.2009 180.248 92.0933 187.129C87.9858 194.01 85.7702 198.766 86.5627 205.758C87.3552 212.749 87.2154 215.375 93.404 220.022C99.5926 224.668 97.5031 225.569 97.5031 225.569L94.1776 225.613C94.1776 225.613 96.8793 231.355 94.8256 234.883L86.5043 227.816L81.1271 231.563L76.1719 214.298C76.1719 214.298 75.1208 201.183 71.7049 194.401C68.2889 187.619 59.3024 170.058 62.403 152.861L91.8915 171.902Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.0821 153.745C65.0821 153.745 74.55 156.023 81.8181 150.487C81.8181 150.487 77.6664 147.974 70.6669 149.482C63.6674 150.991 65.0821 153.745 65.0821 153.745Z",
			fill: "#0E1680"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.286 156.46C68.6396 152.185 61.743 146.563 55.7073 139.249C49.176 131.339 72.2794 132.317 74.2554 143.997C74.8766 147.669 81.3022 153.743 84.8369 157.1C84.5442 158.772 82.6092 166.918 72.3819 168.179C70.9653 164.385 69.9282 160.459 69.286 156.46Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.6246 166.323C85.6246 166.323 87.5165 169.381 85.5127 170.857C83.5088 172.334 80.7981 170.81 80.7981 170.81C79.3955 171.92 77.6708 172.545 75.8828 172.592C74.6295 172.651 73.4207 170.75 72.3828 168.177C82.6091 166.916 84.5441 158.77 84.8379 157.099C85.6111 157.794 86.3478 158.529 87.0451 159.3C88.1834 160.808 85.9872 162.305 85.9872 162.305C85.9872 162.305 87.4766 163.415 87.8008 164.647C88.1251 165.879 85.6246 166.323 85.6246 166.323Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.4437 112.499C51.8993 109.33 53.1191 105.439 54.5669 101.62C59.0176 104.119 65.7134 106.849 75.2565 108.38C74.1854 110.259 73.4402 112.305 73.0524 114.433C62.0589 115.573 54.5191 118.325 50.4951 120.171C50.7111 117.177 51.1447 114.562 51.4437 112.499Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.04 145.205C63.282 142.3 69.8842 140.242 76.6712 139.087C78.1215 143.001 79.8405 146.81 81.8162 150.487C69.4793 148.695 65.0817 153.745 65.0817 153.745C62.0404 151.262 59.3372 148.392 57.0411 145.207L57.04 145.205Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.5664 101.619C56.6534 96.2304 59.0215 90.9555 61.6611 85.8154C61.6611 85.8154 84.8679 100.438 81.9202 102.031C79.1474 103.479 76.8387 105.679 75.2586 108.378C65.7129 106.85 59.0171 104.117 54.5664 101.619Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.0409 145.205C54.8302 142.116 53.1284 138.692 52 135.065C58.9928 132.299 66.2273 130.188 73.6103 128.759H73.613C74.3771 132.273 75.3996 135.726 76.6721 139.09C69.8851 140.244 63.283 142.301 57.0409 145.205Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.4955 120.171C54.5195 118.325 62.0572 115.573 73.0528 114.433C72.1789 118.942 72.594 123.945 73.6104 128.757C66.2274 130.186 58.9929 132.298 52.0001 135.064C50.5684 130.238 50.058 125.186 50.4955 120.171Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.2666 89.079C72.2666 89.079 79.7706 99.0609 89.206 91.9831C98.6414 84.9053 89.8366 74.7646 89.8366 74.7646L77.5997 80.5097L72.2666 89.079Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.428 83.0566C92.6979 76.0754 100.033 80.9544 103.427 65.4377C106.242 52.5675 92.4498 44.632 83.8658 41.1283C72.4807 36.4816 61.525 30.3025 50.1005 38.8213C39.5074 46.72 39.9289 57.7403 42.4278 68.5441C45.9961 83.9505 49.3926 93.2639 59.7813 95.7664C72.6962 98.8718 75.3307 87.8814 82.428 83.0566Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.883 235.302C76.6672 229.557 74.3864 219.191 74.1562 207.824C74.1562 207.824 82.1895 214.387 87.3302 206.09C87.3302 206.09 87.9845 212.606 91.4294 215.542C93.3481 217.177 98.5629 221.367 100.464 226.19C88.0071 224.937 82.6084 232.175 80.883 235.302Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.4152 237.908C89.2665 241.669 84.4017 240.096 80.8838 235.303C82.6096 232.176 88.0079 224.936 100.466 226.19C101.978 230.019 101.398 234.247 95.4152 237.908Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.9065 213.279L75.5283 204.115L85.2979 202.566L84.9963 211.935L79.9065 213.279Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.1929 212.914C85.1929 212.914 86.48 213.243 85.926 214.123L81.4906 217.721C81.4906 217.721 80.2293 217.541 80.4921 216.726L85.1929 212.914Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.8296 215.274C79.8296 215.274 79.6047 214.213 80.836 214.189L86.8796 215.617C86.9348 215.736 86.9614 215.865 86.9571 215.996C86.9528 216.126 86.9177 216.253 86.8547 216.368C86.7918 216.482 86.7027 216.58 86.5948 216.653C86.4869 216.727 86.3631 216.773 86.2337 216.79L79.8296 215.274Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.4443 216.205C86.4443 216.205 87.7582 216.391 87.3057 217.325L83.2912 221.389C83.2912 221.389 82.0173 221.35 82.1875 220.511L86.4443 216.205Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.3737 219.14C81.3737 219.14 81.0332 218.109 82.2545 217.95L88.4179 218.704C88.4859 218.815 88.5266 218.941 88.5367 219.071C88.5468 219.201 88.526 219.332 88.476 219.453C88.426 219.573 88.3482 219.68 88.249 219.765C88.1497 219.85 88.0319 219.91 87.905 219.94L81.3737 219.14Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.304 219.529C88.304 219.529 89.6178 219.715 89.1654 220.649L85.1535 224.713C85.1535 224.713 83.8796 224.674 84.0498 223.835L88.304 219.529Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.2342 222.466C83.2342 222.466 82.8932 221.436 84.1145 221.276L90.2779 222.03C90.3459 222.141 90.3866 222.267 90.3967 222.397C90.4067 222.527 90.3859 222.658 90.3359 222.779C90.2859 222.899 90.2081 223.006 90.1089 223.091C90.0097 223.176 89.8919 223.236 89.765 223.267L83.2342 222.466Z",
			fill: "#F9E0CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.2879 230.808L81.1897 230.664C81.1823 230.653 81.0073 230.389 80.7167 229.884L80.9421 229.755C81.103 230.038 81.2296 230.246 81.31 230.373C81.3589 230.315 81.4083 230.258 81.4577 230.202L81.6527 230.374C81.5659 230.472 81.4808 230.572 81.3962 230.674L81.2879 230.808ZM82.545 229.444L82.3658 229.257C82.6774 228.959 83.008 228.668 83.348 228.394L83.5109 228.596C83.1767 228.866 82.8514 229.151 82.545 229.444ZM80.1029 228.733C79.9095 228.354 79.7187 227.959 79.5348 227.56L79.7707 227.452C79.9531 227.848 80.1428 228.24 80.3341 228.616L80.1029 228.733ZM84.5446 227.83L84.3985 227.616C84.7538 227.375 85.1269 227.143 85.5079 226.924L85.6367 227.149C85.2615 227.364 84.8941 227.593 84.5446 227.83ZM86.7771 226.55L86.6646 226.316C87.0498 226.131 87.4529 225.954 87.8607 225.79L87.9569 226.032C87.5538 226.193 87.1571 226.367 86.7771 226.55ZM79.0119 226.367C78.8458 225.969 78.6834 225.561 78.5305 225.158L78.7733 225.067C78.9251 225.469 79.0886 225.873 79.2515 226.269L79.0119 226.367ZM89.1688 225.59L89.0873 225.344C89.4946 225.209 89.9156 225.081 90.3386 224.971L90.4054 225.221C89.987 225.333 89.5713 225.457 89.1688 225.59ZM91.6608 224.923L91.6083 224.668C92.0287 224.58 92.4623 224.501 92.8922 224.434L92.9321 224.69C92.5064 224.757 92.0786 224.835 91.6608 224.923ZM94.2128 224.523L94.1855 224.265C94.6191 224.219 95.0568 224.184 95.4872 224.16L95.5009 224.419C95.0757 224.442 94.6432 224.478 94.2128 224.523ZM97.654 224.413L97.4843 224.402C97.4816 224.402 97.2299 224.386 96.7921 224.384V224.125C97.0255 224.125 97.2047 224.13 97.325 224.134C97.2883 224.006 97.2431 223.879 97.19 223.757L97.4285 223.655C97.5115 223.845 97.5754 224.043 97.6193 224.246L97.654 224.413ZM78.0906 223.931C77.9529 223.526 77.8184 223.11 77.6907 222.691L77.9393 222.615C78.0659 223.031 78.1994 223.445 78.3366 223.847L78.0906 223.931ZM96.5478 222.665C96.2941 222.32 96.0227 221.988 95.7348 221.671L95.9276 221.497C96.2218 221.821 96.4989 222.16 96.758 222.513L96.5478 222.665ZM77.3317 221.44C77.2188 221.019 77.1115 220.599 77.0127 220.178L77.265 220.119C77.3633 220.535 77.47 220.957 77.5803 221.373L77.3317 221.44ZM94.8403 220.74C94.5534 220.458 94.2459 220.167 93.9001 219.851L94.0746 219.659C94.423 219.978 94.7331 220.271 95.0206 220.552L94.8403 220.74ZM92.9321 218.987C92.601 218.698 92.2715 218.415 91.9499 218.139L92.1186 217.942C92.4407 218.218 92.7713 218.502 93.1029 218.792L92.9321 218.987ZM76.7342 218.905C76.648 218.48 76.5681 218.049 76.4962 217.625L76.7521 217.582C76.8236 218.003 76.9029 218.431 76.9886 218.854L76.7342 218.905ZM90.9624 217.293C90.5541 216.94 90.2435 216.666 89.986 216.431L90.1615 216.239C90.4169 216.473 90.7254 216.745 91.1322 217.096L90.9624 217.293ZM76.3001 216.339C76.2423 215.913 76.1898 215.478 76.1425 215.046L76.401 215.02C76.4457 215.448 76.4972 215.88 76.555 216.304L76.3001 216.339ZM89.061 215.494C88.7856 215.149 88.5444 214.778 88.3411 214.386L88.5707 214.265C88.7662 214.642 88.998 214.999 89.2629 215.331L89.061 215.494ZM76.0305 213.75C76.0001 213.32 75.978 212.882 75.958 212.45L76.2176 212.44C76.2344 212.869 76.2586 213.304 76.2896 213.731L76.0305 213.75ZM87.8071 213.185C87.6616 212.796 87.526 212.377 87.4046 211.938L87.6547 211.869C87.774 212.3 87.907 212.71 88.0505 213.094L87.8071 213.185ZM87.1029 210.665C86.95 209.904 86.8927 209.374 86.8927 209.369L87.1507 209.341C87.1507 209.346 87.2075 209.866 87.3573 210.614L87.1029 210.665Z",
			fill: "#0E1680"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.56 52.9305C69.1951 51.7854 67.093 47.5975 71.5363 44.3066C75.9797 41.0157 80.9375 47.4388 79.1854 50.4968C77.9157 52.713 74.9402 54.566 71.56 52.9305Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.0463 67.4643C80.9077 65.625 82.0565 55.4985 72.1108 53.7427C61.1666 51.8109 56.5966 63.1213 58.4407 68.9074C60.3852 75.0035 63.8574 76.8003 69.8857 75.9695C75.9141 75.1386 79.1855 69.3016 80.0463 67.4643Z",
			fill: "#DD3B33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.7664 69.0545C74.1627 68.2394 72.4957 65.9228 72.9845 65.0725C73.4732 64.2222 74.7607 61.4937 72.7001 59.4494C70.6395 57.4051 67.2089 57.8103 64.8235 60.2114C64.2887 60.7265 63.8836 61.361 63.6412 62.0628C63.3989 62.7647 63.3262 63.5139 63.4292 64.2492C63.5322 64.9845 63.808 65.685 64.2338 66.2932C64.6597 66.9015 65.2236 67.4002 65.8793 67.7486C68.6015 69.3078 69.2033 67.8063 70.3794 68.5936C71.5555 69.3808 71.9197 69.5485 72.7664 69.0545Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.5454 51.3363C77.9222 50.1487 78 47.9824 76.7194 46.4978C75.4388 45.0133 73.2845 44.7725 71.9078 45.96C70.5311 47.1476 70.4532 49.3139 71.7338 50.7985C73.0145 52.2831 75.1687 52.5238 76.5454 51.3363Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.1058 51.152C75.4209 51.152 76.487 50.0859 76.487 48.7708C76.487 47.4557 75.4209 46.3896 74.1058 46.3896C72.7907 46.3896 71.7246 47.4557 71.7246 48.7708C71.7246 50.0859 72.7907 51.152 74.1058 51.152Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.8993 48.0893C75.4477 47.6163 75.4881 46.7642 74.9894 46.1861C74.4908 45.608 73.642 45.5229 73.0936 45.996C72.5452 46.469 72.5048 47.3212 73.0035 47.8992C73.5021 48.4773 74.3509 48.5624 74.8993 48.0893Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.2108 64.2207C71.2108 64.2207 69.0619 60.8689 70.9922 59.6528C72.9224 58.4367 74.6824 63.3657 71.2108 64.2207Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.2733 66.1871C68.2733 66.1871 65.5846 63.3677 64.4858 64.8355C63.3869 66.3033 67.404 69.1632 68.2733 66.1871Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.8696 61.7588C68.0484 61.7588 68.1934 61.6138 68.1934 61.4351C68.1934 61.2563 68.0484 61.1113 67.8696 61.1113C67.6908 61.1113 67.5459 61.2563 67.5459 61.4351C67.5459 61.6138 67.6908 61.7588 67.8696 61.7588Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.9042 60.7528C68.0256 60.7528 68.1239 60.6545 68.1239 60.5331C68.1239 60.4118 68.0256 60.3135 67.9042 60.3135C67.7829 60.3135 67.6846 60.4118 67.6846 60.5331C67.6846 60.6545 67.7829 60.7528 67.9042 60.7528Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.6603 60.3675C68.8135 60.3675 68.9378 60.2432 68.9378 60.09C68.9378 59.9367 68.8135 59.8125 68.6603 59.8125C68.507 59.8125 68.3828 59.9367 68.3828 60.09C68.3828 60.2432 68.507 60.3675 68.6603 60.3675Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.2613 60.9348C67.3954 60.9348 67.5041 60.8261 67.5041 60.692C67.5041 60.5579 67.3954 60.4492 67.2613 60.4492C67.1273 60.4492 67.0186 60.5579 67.0186 60.692C67.0186 60.8261 67.1273 60.9348 67.2613 60.9348Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.9483 60.1857C68.0633 60.1857 68.1565 60.0926 68.1565 59.9776C68.1565 59.8627 68.0633 59.7695 67.9483 59.7695C67.8334 59.7695 67.7402 59.8627 67.7402 59.9776C67.7402 60.0926 67.8334 60.1857 67.9483 60.1857Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.3911 59.5967C68.5699 59.5967 68.7148 59.4517 68.7148 59.2729C68.7148 59.0942 68.5699 58.9492 68.3911 58.9492C68.2123 58.9492 68.0674 59.0942 68.0674 59.2729C68.0674 59.4517 68.2123 59.5967 68.3911 59.5967Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.1676 59.8353C69.34 59.8353 69.4798 59.6955 69.4798 59.5231C69.4798 59.3507 69.34 59.2109 69.1676 59.2109C68.9952 59.2109 68.8555 59.3507 68.8555 59.5231C68.8555 59.6955 68.9952 59.8353 69.1676 59.8353Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.1821 59.0028C69.2842 59.0028 69.367 58.92 69.367 58.8178C69.367 58.7156 69.2842 58.6328 69.1821 58.6328C69.0799 58.6328 68.9971 58.7156 68.9971 58.8178C68.9971 58.92 69.0799 59.0028 69.1821 59.0028Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.2358 60.3007C67.3763 60.3007 67.4902 60.1868 67.4902 60.0463C67.4902 59.9059 67.3763 59.792 67.2358 59.792C67.0953 59.792 66.9814 59.9059 66.9814 60.0463C66.9814 60.1868 67.0953 60.3007 67.2358 60.3007Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.4629 60.7607C66.6225 60.7607 66.7519 60.6313 66.7519 60.4717C66.7519 60.312 66.6225 60.1826 66.4629 60.1826C66.3032 60.1826 66.1738 60.312 66.1738 60.4717C66.1738 60.6313 66.3032 60.7607 66.4629 60.7607Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.8867 61.6953C67.0463 61.6953 67.1757 61.5659 67.1757 61.4062C67.1757 61.2466 67.0463 61.1172 66.8867 61.1172C66.7271 61.1172 66.5977 61.2466 66.5977 61.4062C66.5977 61.5659 66.7271 61.6953 66.8867 61.6953Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.061 61.5351C66.2015 61.5351 66.3154 61.4212 66.3154 61.2807C66.3154 61.1402 66.2015 61.0264 66.061 61.0264C65.9205 61.0264 65.8066 61.1402 65.8066 61.2807C65.8066 61.4212 65.9205 61.5351 66.061 61.5351Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.3062 61.5685C65.402 61.5685 65.4797 61.4909 65.4797 61.3951C65.4797 61.2993 65.402 61.2217 65.3062 61.2217C65.2105 61.2217 65.1328 61.2993 65.1328 61.3951C65.1328 61.4909 65.2105 61.5685 65.3062 61.5685Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.2121 62.2678C66.3653 62.2678 66.4895 62.1436 66.4895 61.9904C66.4895 61.8371 66.3653 61.7129 66.2121 61.7129C66.0588 61.7129 65.9346 61.8371 65.9346 61.9904C65.9346 62.1436 66.0588 62.2678 66.2121 62.2678Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.8629 62.2189C66.9587 62.2189 67.0363 62.1413 67.0363 62.0455C67.0363 61.9497 66.9587 61.8721 66.8629 61.8721C66.7671 61.8721 66.6895 61.9497 66.6895 62.0455C66.6895 62.1413 66.7671 62.2189 66.8629 62.2189Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.2876 62.2714C65.428 62.2714 65.5419 62.1575 65.5419 62.0171C65.5419 61.8766 65.428 61.7627 65.2876 61.7627C65.1471 61.7627 65.0332 61.8766 65.0332 62.0171C65.0332 62.1575 65.1471 62.2714 65.2876 62.2714Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.6844 62.8883C65.8504 62.8883 65.985 62.7537 65.985 62.5877C65.985 62.4217 65.8504 62.2871 65.6844 62.2871C65.5184 62.2871 65.3838 62.4217 65.3838 62.5877C65.3838 62.7537 65.5184 62.8883 65.6844 62.8883Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9277 62.8036C65.049 62.8036 65.1474 62.7052 65.1474 62.5839C65.1474 62.4626 65.049 62.3643 64.9277 62.3643C64.8064 62.3643 64.708 62.4626 64.708 62.5839C64.708 62.7052 64.8064 62.8036 64.9277 62.8036Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.2206 62.7391C64.3036 62.7391 64.3709 62.6718 64.3709 62.5888C64.3709 62.5058 64.3036 62.4385 64.2206 62.4385C64.1376 62.4385 64.0703 62.5058 64.0703 62.5888C64.0703 62.6718 64.1376 62.7391 64.2206 62.7391Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.6238 62.2358C64.7132 62.2358 64.7856 62.1634 64.7856 62.074C64.7856 61.9846 64.7132 61.9121 64.6238 61.9121C64.5344 61.9121 64.4619 61.9846 64.4619 62.074C64.4619 62.1634 64.5344 62.2358 64.6238 62.2358Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4926 63.3495C64.6331 63.3495 64.747 63.2357 64.747 63.0952C64.747 62.9547 64.6331 62.8408 64.4926 62.8408C64.3522 62.8408 64.2383 62.9547 64.2383 63.0952C64.2383 63.2357 64.3522 63.3495 64.4926 63.3495Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.291 40.5948C62.1839 44.1363 62.0342 50.6918 65.952 55.2371C69.8698 59.7823 76.3785 60.5975 80.485 57.0554C84.5915 53.5134 84.7418 46.9584 80.8234 42.4131C76.9051 37.8678 70.3975 37.0538 66.291 40.5948ZM79.9148 56.3943C76.1384 59.6526 70.1541 58.9026 66.5495 54.722C62.9449 50.5415 63.081 44.5131 66.8606 41.2559C70.6402 37.9987 76.6218 38.7476 80.2264 42.9281C83.8311 47.1087 83.6918 53.1397 79.9148 56.3943Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.5762 59.3504C60.5762 59.3504 61.0949 54.4914 66.0501 55.0438L66.6639 55.7553C66.6639 55.7553 64.8414 54.7074 62.734 56.5252C60.6266 58.343 61.056 60.0399 61.056 60.0399L60.5762 59.3504Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.5381 74.9793C62.5381 74.9793 70.626 77.5718 73.5485 70.7031C73.5485 70.7031 80.1481 70.8182 80.4891 63.3389C80.9905 65.3648 79.6882 68.4743 80.2963 69.7608C80.9043 71.0473 85.2688 76.3373 80.0198 80.2635C74.7709 84.1898 71.9435 76.5091 68.619 76.4392C64.1005 76.3446 62.5381 74.9793 62.5381 74.9793Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.585 68.8271C71.585 68.8271 73.4427 71.3055 73.6303 72.4763L75.0309 71.4452C75.0309 71.4452 73.0964 69.1172 72.9088 67.9463L71.585 68.8271Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.3425 57.2911C42.236 60.8326 42.0857 67.388 46.004 71.9333C49.9224 76.4786 56.43 77.2938 60.537 73.7517C64.6441 70.2097 64.7938 63.6547 60.8755 59.1094C56.9571 54.5641 50.4495 53.7501 46.3425 57.2911ZM59.9668 73.0906C56.1898 76.3488 50.2062 75.5989 46.601 71.4183C42.9959 67.2378 43.1357 61.2089 46.9127 57.9522C50.6896 54.6955 56.6733 55.4438 60.2785 59.6244C63.8836 63.805 63.7422 69.8333 59.9668 73.0906Z",
			fill: "#282828"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.8565 70.2725C57.2697 69.2272 59.5416 65.1313 55.2422 61.6571C50.9428 58.1828 45.7175 64.3898 47.3398 67.5209C48.5154 69.788 51.4106 71.764 54.8565 70.2725Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.7681 68.1348C56.1096 66.7052 56.1222 64.5377 54.7964 63.2938C53.4706 62.0498 51.3084 62.2004 49.967 63.6301C48.6255 65.0598 48.6129 67.2272 49.9387 68.4711C51.2645 69.7151 53.4267 69.5645 54.7681 68.1348Z",
			fill: "#4F31FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.4857 68.3903C53.8008 68.3903 54.8668 67.3242 54.8668 66.0091C54.8668 64.694 53.8008 63.6279 52.4857 63.6279C51.1706 63.6279 50.1045 64.694 50.1045 66.0091C50.1045 67.3242 51.1706 68.3903 52.4857 68.3903Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.6229 65.1839C54.1452 64.6272 54.1405 63.7743 53.6124 63.2788C53.0843 62.7832 52.2327 62.8328 51.7104 63.3895C51.1881 63.9462 51.1928 64.7992 51.7209 65.2947C52.249 65.7902 53.1006 65.7406 53.6229 65.1839Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.1895 47.291C94.1895 47.291 101.836 48.8461 104.529 52.2835C103.536 51.7848 102.412 51.6109 101.315 51.7864C103.547 53.4054 105.238 55.6618 106.165 58.2594C106.165 58.2594 103.999 56.3911 102.513 56.5776C101.028 56.7642 94.1895 47.291 94.1895 47.291Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.5449 82.1055C46.5449 82.1055 45.6683 89.1191 47.6674 91.6874C47.6674 91.6874 47.9659 89.9116 48.7074 89.1959C48.7074 89.1959 50.3555 94.5694 54.1729 95.7802C54.1729 95.7802 51.4659 91.9733 52.4003 90.0189C53.3347 88.0644 46.5449 82.1055 46.5449 82.1055Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.865 141.839C145.865 141.839 148.891 152.281 147.247 158.153C147.014 156.747 146.381 155.438 145.425 154.381C145.425 154.381 145.162 162.175 141.282 167.806C141.282 167.806 141.567 164.048 140.691 161.692C139.815 159.336 145.865 141.839 145.865 141.839Z",
			fill: "#FA4F38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173 71.9997L178 76.9997L188 66.9997M197.167 71.9997C197.167 81.2044 189.705 88.6663 180.5 88.6663C171.295 88.6663 163.833 81.2044 163.833 71.9997C163.833 62.7949 171.295 55.333 180.5 55.333C189.705 55.333 197.167 62.7949 197.167 71.9997Z",
			stroke: "#10B981",
			strokeWidth: 3.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgQuokkaDone;
